<template>
	<div class="yanqingBox" :style="{ height: categoryIdx != null ? 100 + 'vh' : ''}">
		<!-- 头部 -->
		<van-sticky v-if="categoryIdx != null ? true: false">
			<div class="headerBox">
				<div class="headerQuery">
					<div class="arrImg" @click="$router.go(-1)">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">言情</p>
				</div>
			</div>
		</van-sticky>
		<van-pull-refresh v-model="isLoading" @refresh="onRefresh" loosing-text="正在获取">
		<div style="width: 100vw;overflow-x: hidden;">
			<!-- 言情金榜 -->
			<div class="yunjin_jbBox">
				<h4>言情金榜<img src="../../assets/img/icon8.png" alt=""></h4>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(item,index) in yqjb"  v-if='item.cover_image !=null'>
							<div v-if="item.cover_image!=undefined" @click='toDetail(item.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
								</div>
								<!-- <p class="bookName">
									<span v-for="(bookName,nameIndex) in item.book_name" v-if="nameIndex > 4 ? false : true">{{bookName}}</span>
								</p> -->
								<p class="jianjie">
									<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
								</p>
							</div>
						</swiper-slide>
						<swiper-slide v-if="yqjb.length>2">
							<router-link to="/yjjb" tag="div">
								<img src="../../assets/img/myicon/yjjbArr02.png" alt="" style="width: 100%;height: 100%;
								background: transparent;box-shadow: 0px 3px 3px 0px rgba(255, 255, 255, 0);padding-top: 10px;"/>
							</router-link>
						</swiper-slide>
					</swiper>
				</div>
			</div>
			<!-- 言情强推 -->
			<div class="shouyeQt">
				<h4>言情强推</h4>
				<div class="qt_list">
					<p v-for="(item,index) in yqqt" @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
				</div>
			</div>
			<!-- 精品 -->
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(xdyq.plate_info_id)">
						<h4>现代言情</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-if='index==0' v-for="(item,index) in xdyq.list" @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList">
						<p v-if='index>0&&index<4' v-for="(item,index) in xdyq.list" @click='toDetail(item.book_id)'>{{item.book_name}}</p>

					</div>
				</div>
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(gdyq.plate_info_id)">
						<h4>古代言情</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-if='index==0' v-for="(item,index) in gdyq.list" @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList">
						<p v-if='index>0&&index<4' v-for="(item,index) in gdyq.list" @click='toDetail(item.book_id)'>{{item.book_name}}</p>

					</div>
				</div>
			</div>
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(hxyq.plate_info_id)">
						<h4>幻想言情</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-if='index==0' v-for="(item,index) in hxyq.list" @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList">
						<p v-if='index>0&&index<4' v-for="(item,index) in hxyq.list" @click='toDetail(item.book_id)'>{{item.book_name}}</p>

					</div>
				</div>
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(ysyq.plate_info_id)">
						<h4>衍生言情</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-if='index==0' v-for="(item,index) in ysyq.list" @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.name" v-if="boIdx >4 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >4 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList new_p">
						<p v-if='index>0&&index<4' v-for="(item,index) in ysyq.list" @click='toDetail(item.book_id)'>{{item.name}}</p>

					</div>
				</div>
			</div>
			<!-- 优品图推 -->
			<div class="yunjin_jbBox">
				<h4>优品图推</h4>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for='(item,index) in yptt'>
							<div @click='toDetail(item.book_id)'>
								<div>
									<img :src="$api.$BASE_URL_img + item.cover_image" alt="">
								</div>
								<!-- <p class="bookName">
									<span v-for="(bookName,nameIndex) in item.book_name" v-if="nameIndex > 4 ? false : true">{{bookName}}</span>
								</p> -->
								<p class="jianjie">
									<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
								</p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
			<!-- 书名 查看更多 -->
			<div class="bookMore">
				<div class="soltType">
					<span v-for="(item,index) in txtspan" :key="index" :class="txtspanindex == index ? 'active' : ''" @click="txtspanitem(index)">{{item}}
						<span class="line" v-show="index != 2&&index != 5">|</span></span>
				</div>
				<div>
					<div class="bookName" v-if="txtspanindex == 0">
						<p v-for='(item,index) in mx' :key='index' 
						v-if="!lookmoreList ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)" 
						@click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
					</div>
					<div class="bookName" v-if="txtspanindex == 1">
						<p v-for='(item,index) in yb' :key='index' 
						v-if="!lookmoreList ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
						 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
					</div>
					<div class="bookName" v-if="txtspanindex == 2">
						<p v-for='(item,index) in jb' :key='index'
						v-if="!lookmoreList ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
						 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
					</div>
					<div class="bookName" v-if="txtspanindex == 3">
						<p v-for='(item,index) in bnb' :key='index' 
						v-if="!lookmoreList ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
						 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
					</div>
					<div class="bookName" v-if="txtspanindex == 4">
						<p v-for='(item,index) in wzz' :key='index'
						v-if="!lookmoreList ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
						 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
					</div>
					<div class="bookName" v-if="txtspanindex == 5">
						<p v-for='(item,index) in yns' :key='index'
						v-if="!lookmoreList ? ((!item.book_name || index > 12) ? false : true) : (!item.book_name ? false : true)"
						 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
					</div>

					<div class="btnMore" @click="showlookmore()">{{lookmoreTitle}}&nbsp;&gt;</div>
				</div>
			</div>
			<!-- VIP -->
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(xdvip.plate_info_id)">
						<h4>现言VIP完结</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-for="(item,index) in xdvip.list" v-if="index == 0" :key='index' @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList" v-for="(item,index) in xdvip.list" v-if="index>0&&index<=3" @click='toDetail(item.book_id)'>
						<p>{{item.book_name}}</p>
					</div>
				</div>
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(gdvip.plate_info_id)">
						<h4>古言VIP完结</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-for="(item,index) in gdvip.list" v-if="index == 0" :key='index' @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList" v-for="(item,index) in gdvip.list" v-if="index>0&&index<=3" @click='toDetail(item.book_id)'>
						<p>{{item.book_name}}</p>
					</div>
				</div>
			</div>
			<div class="jinpinBox">
				<div class="jinpin_left">
					<div class="jp_title" @click="jumpXdyq(hxvip.plate_info_id)">
						<h4>幻言VIP完结</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-for="(item,index) in hxvip.list" v-if="index == 0" :key='index' @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList" v-for="(item,index) in hxvip.list" v-if="index>0&&index<=3" @click='toDetail(item.book_id)'>
						<p>{{item.book_name}}</p>
					</div>
				</div>
				<div class="jinpin_left">
					<div class="jp_title">
						<h4>衍生VIP完结</h4>
						<div>
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
					</div>
					<div class="jp_bookName" v-for="(item,index) in ysvip.list" v-if="index == 0" :key='index' @click='toDetail(item.book_id)'>
						<div class="jp_bookImg">
							<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
						</div>
						<div>
							<p><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >3 ? false : true">{{bookNam}}</span></p>
							<p><span v-for="(authorTxt,boIdx) in item.author" v-if="boIdx >3 ? false : true">{{authorTxt}}</span></p>
							<p><span v-for="(introduceTxt,boIdx) in item.introduce" v-if="boIdx >10 ? false : true">{{introduceTxt}}</span></p>
						</div>
					</div>
					<div class="bookNameList" v-for="(item,index) in hxvip.list" v-if="index>0&&index<=3" @click='toDetail(item.book_id)'>
						<p>{{item.book_name}}</p>
					</div>
				</div>
			</div>

			<!-- 半价完结榜 -->
			<div class="banjia_solt">
				<div class="banjia_title">
					<span>半价完结榜</span>
					<div class="jp_arrImg">
						<img src="../../assets/img/rightarr_pink.png" alt="">
					</div>
				</div>
				<!-- 版块名称 -->
				<div class="swiper_box">
					<swiper class="swiper" :options="bjwj_swiperOption">
						<swiper-slide>
							<!-- <div class="swiper_itembox">
								<span class="swiper_border_pink">古代言情</span>
							</div> -->
							<!-- swiper_bgc_pink  swiper_border_pink -->
							<div class="swiper_bkList">
								<!-- <img src="../../assets/img/yqqp_pink.png" alt="" class="abs_img"> -->
								<div class="bkItem_box">
									<div class="bkItem" v-if="index<=5" @click='toDetail(item.book_id)' v-for="(item,index) in gdbj" :key='index'>
										<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
										<!-- <p><span v-for="(itm,idx) in item.book_name" v-if="idx<=3">{{itm}}</span></p> -->
										<p class="jianjie">
											<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
										</p>
									</div>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<!-- <div class="swiper_itembox">
								<span class="swiper_border_blue">现代言情</span>
							</div> -->
							<!-- swiper_bgc_blue  swiper_border_blue -->
							<div class="swiper_bkList">
								<!-- <img src="../../assets/img/yqqp_blue.png" alt="" class="abs_img"> -->
								<div class="bkItem_box">
									<div class="bkItem" v-if="index <= 5" @click='toDetail(item.book_id)' v-for="(item,index) in xdbj" :key='index'>
										<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
										<!-- <p><span v-for="(itm,idx) in item.book_name" v-if="idx<=3">{{itm}}</span></p> -->
										<p class="jianjie">
											<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 7 ? false : true">{{jianjieTxt}}</span>
										</p>
									</div>
								</div>
							</div>
						</swiper-slide>
						<swiper-slide>
							<!-- <div class="swiper_itembox">
								<span class="swiper_border_skyblue">幻想言情</span>
							</div> -->
							<!-- swiper_bgc_skyblue  swiper_border_skyblue -->
							<div class="swiper_bkList ">
								<!-- <img src="../../assets/img/yqqp_skybule.png" alt="" class="abs_img"> -->
								<div class="bkItem_box">
									<div class="bkItem" v-if="index<=5" @click='toDetail(item.book_id)' v-for="(item,index) in hxbj" :key='index'>
										<img v-if='item.cover_image !=null' :src="$api.$BASE_URL_img + item.cover_image" alt="">
										<!-- <p><span v-for="(itm,idx) in item.book_name" v-if="idx<=3">{{itm}}</span></p> -->
										<p class="jianjie">
											<span v-for="(jianjieTxt,jianjieIndex) in item.introduce" v-if="jianjieIndex > 5 ? false : true">{{jianjieTxt}}</span>
										</p>
									</div>
								</div>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>

			<!-- 最近更新 -->
			<div class="updateBook">
				<div>
					<div class="updata_tit">
						<p v-for="(item,index) in txtspan1" :key="index">
							<span :class="txtspanindex1 == index ? 'active' : ''" @click="txtspanitem1(index)">{{item}}</span>
							<span class="line" v-show="index != 3">|</span></p>
					</div>
				</div>
				<div class="updataName" v-if="txtspanindex1 == 0">
					<p v-for='(item,index) in zjgx' v-if="!item.book_name ? false : true && index <=15" :key='index'
					 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
				</div>
				<div class="updataName" v-if="txtspanindex1 == 1">
					<p v-for='(item,index) in xdzj' v-if="!item.book_name ? false : true && index <=15" :key='index'
					 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
				</div>
				<div class="updataName" v-if="txtspanindex1 == 2">
					<p v-for='(item,index) in gdzj' v-if="!item.book_name ? false : true && index <=15" :key='index'
					 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
				</div>
				<div class="updataName" v-if="txtspanindex1 == 3">
					<p v-for='(item,index) in hxzj' v-if="!item.book_name ? false : true && index <=15" :key='index'
					 @click='toDetail(item.book_id)'><span v-for="(bookNam,boIdx) in item.book_name" v-if="boIdx >9 ? false : true">{{bookNam}}</span></p>
				</div>
			</div>
		</div>
		</van-pull-refresh>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				tabArrindex: null,
				jb_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 30,
					freeMode: false
				},
				//轮播图配置
				bjwj_swiperOption: {
					slidesPerView: 'auto',
					spaceBetween: 0,
					loop: false,
				},
				txtspanindex: 0, //默认tab栏
				txtspanindex1: 0, //默认tab栏
				yqjb: [],
				yqqt: [],
				xdyq: [],
				gdyq: [],
				hxyq: [],
				ysyq: [],
				yptt: [],
				txtspan: ["萌新榜", "月榜", "季榜", "半年榜", "作者榜", "云尼斯频道榜"],
				txtspan1: ["最近更新", "现言", "古言", "幻言"],
				mx: [],
				yb: [],
				jb: [],
				bnb: [],
				wzz: [],
				yns: [],
				xdvip: [],
				gdvip: [],
				hxvip: [],
				ysvip: [],
				xdbj: [],
				gdbj: [],
				hxbj: [],
				gdbj: [],
				zjgx: [],
				xdzj: [],
				gszj: [],
				hxzj: [],
				categoryIdx: null,
				lookmoreList: false,
				lookmoreTitle: '查看更多',
				isLoading: false,
			}
		},
		created() {
			this.get_second_category_list();
			this.categoryIdx = this.$route.query.categoryIdx;
		},
		mounted() {
			// this.get_second_category_list()
		},
		methods: {
			onRefresh() {
				setTimeout(() => {
					// Toast('已获取到最新数据');
					this.get_second_category_list();
					this.isLoading = false;
				}, 1000);
			},
			jumpXdyq(id) {
				console.log(id)
				this.$router.push({
					path: "/gudaiyanqing",
					query: {
						plate_info_id: id
					}
				})
			},
			//tab栏切换
			txtspanitem(data) {
				this.txtspanindex = data
			},
			//tab栏切换
			txtspanitem1(data) {
				this.txtspanindex1 = data
			},
			//跳转详情
			toDetail(val) {
				this.$router.push({
					path: '/bookinfo',
					query: {
						id: val,
						cityPage: 'cityPageUrl'
					}
				})
			},
			//二级分类页面数据
			get_second_category_list() {
				this.$axios.post(`${this.$api.second_category_list}?category_id=15`).then(res => {
					console.log(res, '二级分类页面数据')
					let second_category = res.data.data;
					this.yqjb = second_category[0].list; //言情金榜
					this.yqqt = second_category[1].list; //言情强退
					this.xdyq = second_category[2].list.group1; //现代言情
					this.gdyq = second_category[2].list.group2; //古代言情
					this.hxyq = second_category[2].list.group3; //幻想言情
					this.ysyq = second_category[2].list.group4; //幻想言情
					this.yptt = second_category[3].list; //优品图推
					this.mx = second_category[4].list.group1.list; //萌新榜
					this.yb = second_category[4].list.group2.list; //月榜
					this.jb = second_category[4].list.group3.list; //季榜
					this.bnb = second_category[4].list.group4.list; //半年榜
					this.wzz = second_category[4].list.group5.list; //作者榜
					this.yns = second_category[4].list.group6.list; //云尼斯
					this.xdvip = second_category[5].list.group1; //现代vip
					this.gdvip = second_category[5].list.group2; //古代vip
					this.hxvip = second_category[5].list.group3; //幻想vip
					this.ysvip = second_category[5].list.group4; //幻想vip
					this.xdbj = second_category[6].list.group1.list; //现代半价
					this.gdbj = second_category[6].list.group2.list; //古代半价
					this.hxbj = second_category[6].list.group3.list; //幻想半价
					this.zjgx = second_category[7].list; //最近更新
					this.xdzj = second_category[7].group1; //最近现代言情
					this.gdzj = second_category[7].group2; //最近古代言情
					this.hxzj = second_category[7].group3; //最近幻想言情
				})
			},
			showlookmore() { //查看更多
				if(this.lookmoreList){
					this.lookmoreList = false;
					this.lookmoreTitle = '查看更多';
				}else{
					this.lookmoreList = true;
					this.lookmoreTitle = '收起更多';
				}
			}
		}
	}
</script>

<style scoped="scoped" lang="less">
	.yanqingBox {
		background-color: #f0f0f0;
		overflow-y: scroll;
		height: calc(100vh - 160px);
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 70px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 90px;
				line-height: 90px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
			}

		}

		// tabbar
		.second_box {
			display: flex;
			justify-content: space-between;
			line-height: 70px;
			padding: 0 16px;
			background-color: #fff;

			a {
				font-size: 28px;
			}

			.active {
				transform: scale(1);
				color: #ff4081;
			}
		}

		// 公告css
		.advite_gg {
			display: flex;
			padding: 10px 16px;
			height: 68px;
			line-height: 68px;
			background-color: #fff;
			overflow: hidden;
			position: relative;

			.laba {
				img {
					width: 50px;
					position: absolute;
					top: 50%;
					left: 16px;
					transform: translateY(-50%);
					// height: 66px;
				}
			}

			.swiper_vertical {
				width: calc(100vw - 182px);
				position: absolute;
				top: 50%;
				left: 64px;
				transform: translateY(-50%);
				height: 50px;
				line-height: 50px;
				font-size: 28px;
				/*px*/
				color: #686f70;
				overflow: hidden;
				padding-left: 20px;
				border-radius: 50px;
				background-color: rgba(129, 197, 247, .2);

				.van-swipe .van-swipe__track--vertical .van-swipe-item {
					overflow: hidden;
					white-space: nowrap;
					text-overflow: ellipsis;
				}
			}
		}

		// 云锦金榜
		.yunjin_jbBox {
			height: 370px;
			background-color: #fff;
			border-top: 8px solid #f0f0f0;
			padding: 20px 16px;

			h4 {
				display: inline-block;
				color: #ff4081;
				font-size: 30px;
				/*px*/
				height: 50px;
				line-height: 50px;
				font-weight: 700;
				position: relative;

				img {
					width: 40px;
					position: absolute;
					top: -15px;
					right: -26px;
				}
			}

			.yunjin_jb {
				margin-top: 10px;
				height: 320px !important;
				// height: 270px !important;
				overflow: hidden;
				.swiper-container {
					.swiper-slide {
						// width: 25%;
						// margin-right: 20px !important;
						width: 28% !important;
						margin-right: 15px !important;

						div {
							text-align: center;

							img {
								width: 190px;
								height: 270px;
								vertical-align: middle;
								-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
								box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, 0.3);
								/*no*/
							}
						}

						.bookName,
						.jianjie {
							font-size: 30px;
							/*px*/
							overflow: hidden;
							white-space: nowrap;
							// text-overflow: ellipsis;s
							padding-top: 15px;
							color: #000;
						}

						.jianjie {
							font-size: 24px;
							/*px*/
							color: #000;
							opacity: 0.6;
						}
					}
				}
			}
		}

		//首页强推
		.shouyeQt {
			background-color: #fff;
			margin-top: 10px;
			padding: 0 16px;

			h4 {
				color: #ff4081;
				font-size: 30px;
				/*px*/
				height: 74px;
				line-height: 74px;
			}

			.qt_list {
				overflow: hidden;

				p {
					width: calc(50% - 20px);
					// padding-left: 20px;
					float: left;
					line-height: 60px;
					font-size: 30px;
					/*px*/
					color: #000;
					height: 60px;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}

		}

		//精品
		.jinpinBox {
			margin-top: 10px;
			overflow: hidden;
			background-color: #fff;

			.jinpin_left {
				width: calc(50% - 31px);
				margin-bottom: 10px;
				background-color: #fff;
				float: left;
				padding-left: 16px;
				padding-right: 25px;
				padding-bottom: 16px;
				overflow: hidden;

				.jp_title {
					display: flex;
					height: 78px;
					line-height: 78px;
					position: relative;

					h4 {
						flex: 1;
						font-size: 30px;
						/*px*/
						color: #ff4081;
					}

					div {
						img {
							position: absolute;
							top: 50%;
							transform: translateY(-50%);
							right: 34px;
							width: 50px;
						}
					}
				}

				.jp_bookName {
					display: flex;
					height: 240px;
					position: relative;

					.jp_bookImg {
						position: absolute;
						top: 50%;
						left: 0;
						transform: translateY(-50%);
						width: 155px;
						height: 220px;
						/*px*/
						-webkit-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);
						/*no*/
						box-shadow: 0 3px 3px 0 rgba(0, 0, 0, .3);

						/*no*/
						img {
							width: 155px;
							height: 220px;
							/*px*/
							display: block;
						}
					}

					div:last-child {
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
						text-align: left;
						width: 50%;

						p:first-child {
							// width: 120px;
							font-size: 30px;
							/*px*/
							// font-weight: bold;
							margin-bottom: 10px;
							line-height: 40px;
							height: 40px;
							overflow: hidden;
							color: rgba(0, 0, 0, 1);
						}

						p:nth-child(2) {
							font-size: 26px;
							/*px*/
							line-height: 40px;
							height: 40px;
							overflow: hidden;
							padding-bottom: 10px;
							color: rgba(0, 0, 0, 1);
							opacity: 0.6;
						}

						p:last-child {
							overflow: hidden;
							line-height: 40px;
							height: 80px;
							color: rgba(0, 0, 0, 1);
							opacity: 0.4;
							font-size: 24px;
							/*px*/
						}
					}
				}

				.bookNameList {
					line-height: 50px;
					font-size: 30px;
					/*px*/
					padding-top: 10px;
				}
				
				.new_p{
					p{
						width:100%;
						overflow: hidden;
						height:48px;
					}
				}
			}

			.jinpin_left:nth-child(2n) {
				padding-right: 16px;
				padding-left: 5px;
			}

		}

		// 查看更多
		.bookMore {
			margin-top: 10px;
			background-color: #fff;
			padding: 0 16px;

			.soltType {
				padding: 20px 0;
				overflow: hidden;

				span {
					width: 33.33%;
					float: left;
					display: inline-block;
					line-height: 80px;
					overflow: hidden;
					text-align: left;
					font-size: 28px;
					/*px*/
					color: #FF4081;

					span {
						float: right;
						color: #dbdbdb;
					}
				}

				span.active {
					font-size: 32px;
					font-weight: bold;
					color: #ff4081;
				}

			}

			.bookName {
				line-height: 60px;
				overflow: hidden;

				// p {
				// 	width: 50%;
				// 	float: left;
				// 	font-size: 28px;
				// 	/*px*/
				// 	color: #585858;
				// }
				p {
					display: block;
					width: calc(50% - 40px);
					margin-right: 10px;
					padding-right: 10px;
					height: 60px;
					overflow: hidden;
					white-space: nowrap;
					float: left;
					text-align: left;
					font-size: 30px;
					/*px*/
					line-height: 60px;
					color: #000;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}

			.btnMore {
				text-align: center;
				line-height: 50px;
				color: #9a9a9a;
				padding: 20px;
				font-size: 30px;
				/*px*/
			}
		}

		//半价完结榜
		.banjia_solt {
			background: #fff;
			margin-top: 10px;

			// 标题
			.banjia_title {
				position: relative;
				height: 80px;
				display: flex;
				justify-content: space-between;
				line-height: 80px;
				padding: 0 16px;

				span {
					font-size: 30px;
					/*px*/
					color: #ff4081;
					font-weight: bold;
				}

				.jp_arrImg {
					height: 50px;

					img {
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						right: 34px;
						width: 35px;
					}
				}
			}

			//轮播
			// 板块
			.swiper_box {
				background-color: #fff;
				padding-bottom: 20px;

				.swiper-wrapper {
					height: 500px;
				}

				//轮播
				.swiper-container {
					height: 100%;
					background-color: #fff;

					.swiper-slide {
						width: 70% !important;
						margin: 0px 10px !important;
						display: flex;

						.swiper_itembox {
							span {
								margin-top: 100px;
								margin-left: 20px;
								padding: 30px 0;
								padding-top: 100px;
								padding-left: 10px;
								display: inline-block;
								height: 220px;
								width: 40px;
								font-size: 30px;
								/*px*/
								background-color: #fff;
								border-top-left-radius: 12px;
								/*no*/
								border-bottom-left-radius: 12px;
								;
								/*no*/
							}
						}

						.swiper_border_pink {
							-webkit-box-shadow: 1px 4px 15px 0px rgba(255, 77, 137, .3);
							/*no*/
							-moz-box-shadow: 1px 4px 15px 0px rgba(255, 77, 137, .3);
							/*no*/
							box-shadow: 1px 4px 15px 0px rgba(255, 77, 137, .3);
							/*no*/
						}

						.swiper_border_blue {
							-webkit-box-shadow: 1px 4px 15px 0px rgba(129, 197, 247, .3);
							/*no*/
							-moz-box-shadow: 1px 4px 15px 0px rgba(129, 197, 247, .3);
							/*no*/
							box-shadow: 1px 4px 15px 0px rgba(129, 197, 247, .3);
							/*no*/
						}

						.swiper_border_skyblue {
							-webkit-box-shadow: 1px 4px 15px 0px rgba(37, 206, 222, .3);
							/*no*/
							-moz-box-shadow: 1px 4px 15px 0px rgba(37, 206, 222, .3);
							/*no*/
							box-shadow: 1px 4px 15px 0px rgba(37, 206, 222, .3);

							/*no*/
							.rotate_txt {
								display: block;
								padding-top: 10px;
								padding-left: 15px;
								font-style: normal;
								-webkit-transform: rotate(90deg);
								-moz-transform: rotate(90deg);
								transform: rotate(90deg);
							}
						}

						.swiper_bgc_pink {
							border: 1px solid #ff4d89;
							/*no*/
							background-color: #fff8fa;
						}

						.swiper_bgc_blue {
							border: 1px solid #81c5f7;
							/*no*/
							background-color: #eff8fe;
						}

						.swiper_bgc_skyblue {
							border: 1px solid #25cede;
							/*no*/
							background-color: #f3fcfc;
						}

						.swiper_bkList {
							flex: 1;
							border-radius: 20px;
							position: relative;
							height: 550px;
							// display: flex;
							padding: 20px 10px;

							// overflow: hidden;
							.abs_img {
								width: 80px;
								position: absolute;
								top: -30px;
								left: -30px;
							}

							.bkItem_box {
								margin: 0 auto;
								padding-left: 15px;

								.bkItem {
									width: calc((100% - 40px) / 3);
									float: left;
									text-align: center;
									font-size: 24px;
									/*px*/
									// margin-top: 30px;
									margin-right: 15px;

									img {
										width: 155px;
										height: 220px;
										/*px*/
										-webkit-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, .3);
										/*no*/
										-moz-box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, .3);
										/*no*/
										box-shadow: 0px 3px 3px 0px rgba(0, 0, 0, .3);
										/*no*/
									}
									.jianjie{
										color: #000;
										opacity: 0.6;
										font-size: 24px;/*px*/
										height: 40px;
										line-height: 40px;
									}
								}

								.bkItem:nth-child(3n) {
									margin-right: 0;
								}

								p {
									font-size: 30px;
									/*px*/
									overflow: hidden;
									white-space: nowrap;
									// text-overflow: ellipsis;
									line-height: 60px;
									color: #000;
								}
							}

						}
					}
				}

			}



		}

		//最近更新
		.updateBook {
			margin-top: 10px;
			background-color: #fff;
			padding: 0 16px;

			div:first-child {
				display: flex;
			}

			.updata_tit {
				flex: 1;
				display: flex;
				padding: 20px 0;
				p{
					width: calc((100vw - 20px) / 4);
					position: relative;
				}
				p:first-of-type{
					width: 200px;
					.line{
						position: absolute;
						top: 0%;
						right: 15%;
					}
				}
				span {
					font-size: 30px;
					/*px*/
					color: #fa7298;
				}
				
				span.active {
					transform: scale(1.1);
					color: #ff4081;
					font-weight: bold;
				}
				
				.line {
					color: #dbdbdb;
					position: absolute;
					top: 0%;
					right: 25%;
				}
			}

			.updataName {
				overflow: hidden;
				padding: 0 0 20px 0;
				p {
					width: calc(50% - 20px);
					// padding-left: 20px;
					float: left;
					line-height: 60px;
					font-size: 30px;
					/*px*/
					color: #000;
					height: 60px;
					overflow: hidden;
				}

				p:nth-child(2n) {
					padding-left: 30px;
				}
			}
		}
	}
</style>
